/**
 * Shared types and constants for room labeling - extracted to break circular dependency
 * between planRoomLabelFormatting.ts and roomDecompositionForLabeling.ts
 */
import type { FloorAssembly } from "building-types/floors/floorAssemblyTypes";
import type { FloorSystem } from "building-types/floors/floorSystemTypes";
import type { RoomTagRowsControl } from "building-types/rooms/roomTag";
import type { Room } from "building-types/rooms/roomTypes";
import type { Table } from "common/data/table";

export const ROOM_AREA_THRESHOLD_TO_SWITCH_TO_SHORT_NAME = 2880;

export type RoomLabelFormatterSettings = RoomTagRowsControl;

export type RoomLabelFormatter = (
  settings: RoomLabelFormatterSettings,
  room: Room,
  roomFloorAssemblies: Table<FloorAssembly>,
  floorSystems: Table<FloorSystem>,
) => string;
